import { useCallback } from "react";
import { Button } from "@/components/Buttons/index";
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ResumeSelect(_ref) {
  var state = _ref.state;
  var handleContinue = useCallback(function () {
    state.updateResumePoint(state.playbackAuth.resumePoint);
  }, []);
  var handleFirst = useCallback(function () {
    state.updateResumePoint(0);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.resume,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.buttons,
      children: [/*#__PURE__*/_jsx(Button, {
        fillColor: true,
        medium: true,
        onClick: handleContinue,
        children: "\u7D9A\u304D\u304B\u3089\u518D\u751F"
      }), /*#__PURE__*/_jsx(Button, {
        fillColor: true,
        medium: true,
        onClick: handleFirst,
        children: "\u6700\u521D\u304B\u3089\u518D\u751F"
      })]
    })
  });
}